module.exports = __webpack_public_path__ + "img/t5-i4.72c3deaa.svg";